<template>
 
    <div class="cc-popup" v-if="show" @click="closePopup()">

        <!-- Modal content -->
        <div 
        class="cc-popup-content"  
        :style="{width: width ? width+'px' : ''}"
        v-on:click.stop="">
            
            <slot></slot>

        </div>

    </div>

</template>

<style>

</style>

<script>

export default {
    name: 'ccPopup',

    model: {
		prop: "show",
		event: "close",
    },
    
    data () {
        return {
        }
    },

    props: {

        show: {
            type: Boolean,
            default: false
        },

        persistent: { // disable click outside popup and close
            type: Boolean,
            default: false
        },

        width: { // disable click outside popup and close
            type: String,
            default: null
        },

    },

    methods: {

        closePopup(){
            
            if(!this.persistent){

                this.show = false ; 

                this.$emit(
                    "close",
                    this.show
                );
                
            }
            
        },
        getWidth(){

            if(this.width){
                return "{'width':this.width}" ;
            }
            
        }

    }

}

</script>